/* Auto-generated i18n data for Forge3DLab store landing. Default: us (English). */
window.I18N = {
  "us": {
    "nav.home": "Home",
    "nav.assistance": "Assistance",
    "announce.1": "🔥 Launch offer — 56% off",
    "announce.2": "⚡ Instant digital download",
    "announce.3": "📦 10,000+ STL models",
    "announce.4": "🛡️ 14-day money-back guarantee",
    "announce.5": "🌍 5 languages included",
    "hero.badge": "10,000+ hand-picked STL models, sorted by category",
    "hero.title": "Is your 3D printer gathering dust?",
    "hero.lead": "10,000+ print-ready STL models people <b>actually buy</b> — plus expert guides to sell them and a complete business manager to run the numbers. Download it once, keep it forever, and stop paying for every single file.",
    "hero.ctaGet": "Buy now",
    "hero.title.dusty": "Bring your dusty 3D printer back to life",
    "hero.lead.dusty": "That printer sitting unused? 10,000+ print-ready STL models to <b>fire it back up</b> — plus expert guides and a complete business manager to make some money with it. Download once, keep it forever.",
    "hero.ctaGet.dusty": "Put it back to work",
    "hero.title.search": "Stop searching 20 sites for the perfect model",
    "hero.lead.search": "Everything worth printing, in one bundle: 10,000+ print-ready STL models, organized by category — plus expert guides and a complete business manager. Download once, keep it forever, <b>never hunt for files again</b>.",
    "hero.ctaGet.search": "Get the whole library",
    "hero.title.earn": "From hobby to extra income",
    "hero.lead.earn": "10,000+ print-ready STL models people <b>actually buy</b> — plus expert guides to sell them and a complete business manager to run the numbers. Download once, keep it forever, and turn your printer into a real side income.",
    "hero.ctaGet.earn": "Start earning",
    "hero.ctaInside": "See what's inside",
    "zoom.tipHold": "Press and hold here",
    "zoom.tipClick": "Click to enlarge",
    "hero.b1": "<b>10,000+ models:</b> pay once, print forever",
    "hero.b2": "<b>4 masterclass guides:</b> perfect prints, right prices, first customers",
    "hero.b3": "<b>Complete business manager:</b> know your profit before you hit Print",
    "hero.b4": "<b>Commercial license included</b> — sell what you print, keep 100%.",
    "hero.trust1": "💳 <b>One-time</b> payment — no subscription",
    "hero.trust2": "⚡ <b>Instant</b> digital download",
    "hero.trust3": "🛡️ <b>14-day</b> money-back guarantee",
    "hero.trust4": "📦 <b>$0 shipping</b> — 100% digital",
    "hero.trust5": "📜 <b>Commercial license included</b> — sell what you print",
    "idx.categories": "What you can print",
    "cat.title": "Why choose Forge3DLab?",
    "cat.lead": "Not just files: the library, the method to sell them and the tool to run it.",
    "cat.more": "…and thousands more across every category — <b>10,000+ files</b> in one download.",
    "idx.inside": "Not just files — a system",
    "inside.title": "Three things in one pack. No guessing.",
    "inside.lead": "The files to print, the know-how to sell what you make, and the manager that costs, prices and tracks it all.",
    "inside.tag1": "01 · Library",
    "inside.h1": "10,000+ STL models",
    "inside.p1": "Categorized and sorted — ready to slice on any printer.",
    "inside.tag2": "02 · Guides",
    "inside.h2": "4 expert guides",
    "inside.p2": "Print flawlessly, find what sells, price it right, and scale — from first layer to first sale.",
    "inside.tag3": "03 · Manager",
    "inside.h3": "Complete business manager",
    "inside.p3": "A system built to walk you through it, step by step.",
    "inside.cta3": "Discover it now",
    "pain.title": "Owning a printer isn't the hard part. Knowing what to print — and sell — is.",
    "pain.lead": "Endless file-hunting. Paying $8–12 per single STL. Models that never sell. No idea what to charge. Forge3DLab hands you the shortcut — no design skills needed.",
    "idx.features": "Why Forge3DLab",
    "feat.title": "Everything you need to earn — in one download.",
    "feat.h1": "10,000+ STL models",
    "feat.p1": "A curated, categorized library — decor, functional, gadgets, collectibles and best-sellers, ready to slice.",
    "feat.h2": "4 expert guides",
    "feat.p2": "From flawless prints (no more warping or wasted filament) to what sells, pricing and scaling — the whole path.",
    "feat.h3": "Complete business manager",
    "feat.p3": "See your real profit after filament, time and fees — run it like a business, not a hobby.",
    "feat.h4": "Commercial license included",
    "feat.p4": "A full commercial license is included — sell what you print and keep 100% of your profit, no royalties.",
    "feat.h5": "Instant access",
    "feat.p5": "Pay once, download immediately. No subscription required to get started.",
    "feat.h6": "Lifetime updates",
    "feat.p6": "Add lifetime access and every new model, guide upgrade and bonus lands in your library — forever.",
    "panel1.title": "Files that are actually worth printing.",
    "panel1.lead": "Hand-picked and organized — not a random 400 GB dump of files. Go straight to models people actually buy.",
    "idx.how": "How it works",
    "how.title": "From idle printer to first sale in three steps.",
    "how.s1h": "Download",
    "how.s1p": "Get the full library, guides and manager instantly after checkout.",
    "how.s2h": "Print",
    "how.s2p": "Pick a proven model, slice it, print — the guides tell you what sells.",
    "how.s3h": "Sell",
    "how.s3p": "Price it right with the manager and turn your printer into income.",
    "idx.reviews": "Makers using Forge3DLab",
    "rev.title": "Printers that stopped collecting dust.",
    "rev2.title": "More printers that stopped collecting dust.",
    "idx.reviews2": "More makers",
    "rev.avg": "4.7/5 average · verified buyers",
    "rev.q1": "Had my printer 8 months doing nothing. First weekend with the guides I sold 3 prints.",
    "rev.q2": "The manager alone is worth it. I finally know what I actually earn per print.",
    "rev.q3": "Stopped buying files one by one. 10k models in one pack paid for itself immediately.",
    "rev.q4": "No design skills here. The guides told me exactly what to print and where to sell it.",
    "rev.q5": "Printed the entire fantasy wizard set in one weekend. The detail is insane for FDM — my D&D group was speechless. 🧙",
    "rev.q6": "My son wanted every character from his favourite show. Printed 6 in two days — one needed support tweaks, the rest came out perfect.",
    "rev.q7": "The lamp designs in the Home category are on another level. One's in my living room now and everyone asks where I bought it.",
    "rev.q8": "I didn't believe I could actually sell these. First week on Etsy: 4 orders. The business guide changed everything. 🔥",
    "rev.q9": "Made three of these for my home office. Clean, functional — people keep asking if they're store-bought. Worth it.",
    "rev.q10": "Sci-fi fan here. The collectibles section has hundreds of characters. Already printed 12, no signs of stopping. 😂",
    "rev.q11": "Stunning planter designs. Printed four, painted two, sold them at a local market the same week.",
    "rev.q12": "This is what 3 months of printing looks like. The STL library is massive — I haven't run out of ideas once.",
    "rev.q13": "The monitor stand STL is genius. Printed it in PETG, holds perfectly. I'd just love a few more size variants.",
    "rev.q14": "My kid picked the excavator from the file list on a Tuesday. By Thursday he was playing with it. Magic. ✨",
    "rev.q15": "This drawer unit took two days to print. Solid, fits perfectly under my desk. I've sold three more to colleagues since.",
    "rev.q16": "The office section has 60+ organizer designs. I've printed five configurations — my desk has never looked better. 🖊️",
    "rev.verified": "Verified",
    "panel2.title": "The whole system, one price.",
    "stat.models": "STL models",
    "stat.guides": "Expert guides",
    "stat.categories": "Categories",
    "stat.updates": "Lifetime updates",
    "idx.offer": "Get the bundle",
    "offer.title": "10,000+ models, 4 guides and the manager in one pack",
    "offer.lead": "One-time payment. Instant access. 14-day money-back guarantee.",
    "offer.badge": "Launch offer · 56% off",
    "offer.launch": "Launch price — regular price is $89",
    "offer.sub": "Forge3DLab — complete bundle · one-time",
    "offer.incl1": "10,000+ STL models",
    "offer.incl2": "4 masterclass guides",
    "offer.incl3": "Complete business manager system",
    "offer.incl4": "Commercial license included",
    "offer.incl5": "Instant digital download",
    "offer.ctaMain": "Add to cart",
    "offer.guarantee": "Secure checkout · $0 shipping · instant delivery · 14-day guarantee",
    "offer.addonBadge": "Add-on",
    "offer.addonSub": "Lifetime Updates Access",
    "offer.addon1": "Every future STL model added — free",
    "offer.addon2": "Guide upgrades & new bonuses",
    "offer.addon3": "Your library never goes stale",
    "offer.ctaAddon": "Add lifetime",
    "guar.1": "14-day money-back guarantee",
    "guar.2": "Instant download",
    "guar.3": "Secure Shopify checkout",
    "guar.4": "No subscription",
    "guar.5": "$0 shipping — 100% digital",
    "idx.faq": "FAQ",
    "faq.title": "Questions, answered.",
    "faq.q1": "What exactly do I get?",
    "faq.a1": "The full Forge3DLab bundle: 10,000+ categorized STL models, 4 expert guides, and the business manager — an instant digital download right after checkout.",
    "faq.q2": "Can I sell what I print?",
    "faq.a2": "Yes — a full commercial-use license is included. Print and sell what you make, keep 100% of your profit with no royalties, and build a real side income.",
    "faq.q3": "Do I need design skills or special software?",
    "faq.a3": "No. Files are standard STL — they work with any common slicer (Cura, Bambu Studio, PrusaSlicer) and any FDM or resin printer. The guides handle the rest.",
    "faq.q4": "Is it a subscription?",
    "faq.a4": "No. The bundle is a one-time payment with instant access. Lifetime Updates is an optional one-time add-on, not a recurring charge.",
    "faq.q5": "What if it's not for me?",
    "faq.a5": "You're covered by a 14-day money-back guarantee. If it's not a fit, email us within 14 days for a full refund.",
    "final.title": "Your printer is ready. Give it something worth printing.",
    "final.lead": "10,000+ STL models, expert guides and a complete business manager — one download,",
    "final.guarantee": "$0 shipping · instant download · 14-day money-back guarantee",
    "footer.categories": "Categories",
    "footer.inside": "What's inside",
    "footer.reviews": "Reviews",
    "footer.pricing": "Pricing",
    "footer.faq": "FAQ",
    "footer.contact": "Contact",
    "footer.privacy": "Privacy policy",
    "footer.terms": "Terms of service",
    "footer.refunds": "Refund policy",
    "footer.withdrawal": "Withdraw from contract here",
    "footer.legalContact": "Legal notice",
    "footer.privacyChoices": "Your privacy choices",
    "footer.bot": "© 2026 Forge3DLab · Turn your 3D printer into income · Instant digital download · 14-day money-back guarantee",
    "cat.c.miniatures": "D&D packs · Lord of the Rings · Anime · Superheroes · Mixed · Film & TV · Chibi · Cartoons · Board games",
    "cat.c.home": "Modern decor · Functional · Kitchen · Lamps · Cookie cutters · Headphone stands",
    "cat.c.jewelry": "3 complete packs · Rings · Earrings · Bracelets · Necklace charms · Pendants",
    "cat.c.keychain": "5 packs · Custom keychains · Custom name tags · Character charms",
    "cat.c.heroes": "Marvel · DC · Chibi style · Action poses · Numbered 1 to 645+",
    "cat.c.funko": "CHIBI series · PlaKit/Patreon · Full pop-culture roster",
    "cat.c.cosplay": "ELMET-MASK collection · Helmets · Masks · Wearable props · Numbered 1 to 300+",
    "cat.c.office": "Organizers · Desk accessories · Cable management · Tool holders · Workspace upgrades · Office prints",
    "cat.hint": "Tap a category to see what's inside — hover on desktop.",
    "cat.c.tools": "Wrenches · Pliers · Hooks · Clamps · Funnels · Measuring tools · Workshop helpers",
    "cat.c.toys": "Articulated figures · Fidget toys · Puzzles · Cars · Dinosaurs · Kids' prints",
    "cat.c.vehicles": "Cars · Planes · Tanks · Ships · Motorcycles · Scale models"
  },
  "it": {
    "nav.home": "Home",
    "nav.assistance": "Assistenza",
    "announce.1": "🔥 Offerta lancio — sconto 56%",
    "announce.2": "⚡ Download digitale immediato",
    "announce.3": "📦 10.000+ modelli STL",
    "announce.4": "🛡️ Garanzia soddisfatti o rimborsati 14 giorni",
    "announce.5": "🌍 5 lingue incluse",
    "hero.badge": "10.000+ modelli STL scelti a mano, divisi per categoria",
    "hero.title": "La tua stampante 3D sta prendendo polvere?",
    "hero.lead": "10.000+ modelli STL pronti da stampare che la gente compra <b>davvero</b> — più le guide degli esperti per venderli e un gestionale per tenere i conti. Scaricalo una volta, è tuo per sempre: basta pagare ogni singolo file.",
    "hero.ctaGet": "Acquista subito",
    "hero.title.dusty": "Rimetti in moto la stampante che non usi",
    "hero.lead.dusty": "Quella stampante ferma a prendere polvere? 10.000+ modelli STL pronti per <b>rimetterla in funzione</b> — più guide esperte e un gestionale per farci anche qualche soldo. Scarichi una volta, è tua per sempre.",
    "hero.ctaGet.dusty": "Rimettila al lavoro",
    "hero.title.search": "Basta cercare su 20 siti il modello perfetto",
    "hero.lead.search": "Tutto quello che vale la pena stampare, in un solo pacchetto: 10.000+ modelli STL pronti, organizzati per categoria — più guide esperte e un gestionale. Scarichi una volta, è tuo per sempre: <b>mai più caccia ai file</b>.",
    "hero.ctaGet.search": "Prendi tutta la libreria",
    "hero.title.earn": "Da hobby a reddito extra",
    "hero.lead.earn": "10.000+ modelli STL pronti da stampare che la gente compra <b>davvero</b> — più le guide degli esperti per venderli e un gestionale per tenere i conti. Scarichi una volta, è tuo per sempre: trasforma la stampante in una vera entrata extra.",
    "hero.ctaGet.earn": "Inizia a guadagnare",
    "hero.ctaInside": "Guarda cosa contiene",
    "zoom.tipHold": "Tieni premuto qui",
    "zoom.tipClick": "Clicca per ingrandire",
    "hero.b1": "<b>10.000+ modelli:</b> paghi una volta, stampi per sempre",
    "hero.b2": "<b>4 guide masterclass:</b> stampe perfette, prezzi giusti, primi clienti",
    "hero.b3": "<b>Gestionale completo:</b> il guadagno lo sai prima di premere Stampa",
    "hero.b4": "<b>Licenza commerciale inclusa</b> — vendi quello che stampi, tieni il 100%.",
    "hero.trust1": "💳 Pagamento <b>unico</b> — nessun abbonamento",
    "hero.trust2": "⚡ Download digitale <b>immediato</b>",
    "hero.trust3": "🛡️ Garanzia <b>14 giorni</b> soddisfatti o rimborsati",
    "hero.trust4": "📦 <b>€0 di spedizione</b> — 100% digitale",
    "hero.trust5": "📜 <b>Licenza commerciale inclusa</b> — vendi quello che stampi",
    "idx.categories": "Cosa puoi stampare",
    "cat.title": "Perché scegliere Forge3DLab?",
    "cat.lead": "Non solo file: la libreria, il metodo per venderli e lo strumento per gestirli.",
    "cat.more": "…e migliaia di altri in ogni categoria — <b>10.000+ file</b> in un solo download.",
    "idx.inside": "Non solo file — un sistema",
    "inside.title": "Tre cose in un solo pacchetto. Niente tentativi alla cieca.",
    "inside.lead": "I file da stampare, il know-how per vendere ciò che stampi e il gestionale che calcola costi, prezzi e profitto reale.",
    "inside.tag1": "01 · Libreria",
    "inside.h1": "10.000+ modelli STL",
    "inside.p1": "Selezioni catalogate e divise per categoria — pronte da slicer su qualsiasi stampante.",
    "inside.tag2": "02 · Guide",
    "inside.h2": "4 guide di esperti",
    "inside.p2": "Stampa senza errori, scopri cosa vende, fissa il prezzo giusto e cresci — dal primo layer alla prima vendita.",
    "inside.tag3": "03 · Gestionale",
    "inside.h3": "Gestionale completo",
    "inside.p3": "Un sistema sviluppato per seguirti passo passo.",
    "inside.cta3": "Scoprilo ora",
    "pain.title": "Avere una stampante non è la parte difficile. Sapere cosa stampare — e vendere — lo è.",
    "pain.lead": "Ricerche di file senza fine. Pagare $8–12 per un singolo STL. Modelli che non vendono mai. Nessuna idea su quanto chiedere. Forge3DLab ti dà la scorciatoia — senza competenze di design.",
    "idx.features": "Perché Forge3DLab",
    "feat.title": "Tutto ciò che ti serve per guadagnare — in un solo download.",
    "feat.h1": "10.000+ modelli STL",
    "feat.p1": "Una libreria selezionata e catalogata — decorazioni, oggetti funzionali, gadget, da collezione e best-seller, pronti da slicer.",
    "feat.h2": "4 guide di esperti",
    "feat.p2": "Dalle stampe perfette (basta warping e filamento sprecato) a cosa vende, prezzi e crescita — l'intero percorso.",
    "feat.h3": "Gestionale completo",
    "feat.p3": "Vedi il tuo profitto reale dopo filamento, tempo e commissioni — gestiscila come un'attività, non come un hobby.",
    "feat.h4": "Licenza commerciale inclusa",
    "feat.p4": "È inclusa una licenza commerciale completa — vendi ciò che stampi e tieni il 100% del profitto, zero royalty.",
    "feat.h5": "Accesso immediato",
    "feat.p5": "Paghi una volta, scarichi subito. Nessun abbonamento richiesto per iniziare.",
    "feat.h6": "Aggiornamenti a vita",
    "feat.p6": "Aggiungi l'accesso a vita e ogni nuovo modello, aggiornamento delle guide e bonus arriva nella tua libreria — per sempre.",
    "panel1.title": "File che vale davvero la pena stampare.",
    "panel1.lead": "Scelti a mano e organizzati — non un dump a caso di file. Vai dritto ai modelli che la gente compra davvero.",
    "idx.how": "Come funziona",
    "how.title": "Dalla stampante ferma alla prima vendita in tre passi.",
    "how.s1h": "Scarica",
    "how.s1p": "Ottieni la libreria completa, le guide e il gestionale subito dopo il checkout.",
    "how.s2h": "Stampa",
    "how.s2p": "Scegli un modello collaudato, fai lo slicing, stampa — le guide ti dicono cosa vende.",
    "how.s3h": "Vendi",
    "how.s3p": "Fissa il prezzo giusto con il gestionale e trasforma la tua stampante in un guadagno.",
    "idx.reviews": "Maker che usano Forge3DLab",
    "rev.title": "Stampanti che hanno smesso di prendere polvere.",
    "rev2.title": "Altre stampanti che hanno smesso di prendere polvere.",
    "idx.reviews2": "Altri maker",
    "rev.avg": "4,7/5 di media · acquirenti verificati",
    "rev.q1": "Avevo la stampante ferma da 8 mesi. Il primo weekend con le guide ho venduto 3 stampe.",
    "rev.q2": "Vale già solo per il gestionale. Finalmente so quanto guadagno davvero per ogni stampa.",
    "rev.q3": "Basta comprare file uno alla volta. 10k modelli in un pacchetto si sono ripagati subito.",
    "rev.q4": "Zero competenze di design. Le guide mi hanno detto esattamente cosa stampare e dove venderlo.",
    "rev.q5": "Ho stampato l'intero set di maghi fantasy in un weekend. Il dettaglio è pazzesco per l'FDM — il mio gruppo D&D è rimasto senza parole. 🧙",
    "rev.q6": "Mio figlio voleva ogni personaggio del suo cartone preferito. Ne ho stampati 6 in due giorni — uno ha richiesto qualche ritocco ai supporti, gli altri perfetti.",
    "rev.q7": "Le lampade nella categoria Home sono di un altro livello. Una è nel mio salotto e tutti mi chiedono dove l'ho comprata.",
    "rev.q8": "Non credevo di poterle vendere davvero. Prima settimana su Etsy: 4 ordini. La guida al business ha cambiato tutto. 🔥",
    "rev.q9": "Ne ho fatti tre per il mio ufficio in casa. Puliti, funzionali — la gente continua a chiedermi se li ho comprati. Ne vale la pena.",
    "rev.q10": "Fan della fantascienza qui. La sezione collezionabili ha centinaia di personaggi. Già stampati 12, non ho intenzione di fermarmi. 😂",
    "rev.q11": "Vasi dal design stupendo. Ne ho stampati quattro, dipinti due, venduti a un mercatino la stessa settimana.",
    "rev.q12": "Ecco com'è 3 mesi di stampa. La libreria STL è enorme — non sono mai rimasto senza idee.",
    "rev.q13": "Il supporto per monitor è geniale. Stampato in PETG, tiene alla perfezione. Vorrei solo qualche variante di misura in più.",
    "rev.q14": "Mio figlio ha scelto l'escavatore dalla lista dei file un martedì. Giovedì ci giocava già. Magia. ✨",
    "rev.q15": "Questo cassettone ha richiesto due giorni di stampa. Solido, si incastra perfettamente sotto la scrivania. Ne ho già venduti tre ai colleghi.",
    "rev.q16": "La sezione ufficio ha oltre 60 organizer. Ne ho stampati cinque diversi — la mia scrivania non è mai stata così in ordine. 🖊️",
    "rev.verified": "Verificata",
    "panel2.title": "L'intero sistema, un solo prezzo.",
    "stat.models": "modelli STL",
    "stat.guides": "guide di esperti",
    "stat.categories": "categorie",
    "stat.updates": "aggiornamenti a vita",
    "idx.offer": "Ottieni il pacchetto",
    "offer.title": "10.000+ modelli, 4 guide e il gestionale in un unico pacchetto",
    "offer.lead": "Pagamento unico. Accesso immediato. Garanzia soddisfatti o rimborsati 14 giorni.",
    "offer.badge": "Offerta lancio · sconto 56%",
    "offer.launch": "Prezzo di lancio — il prezzo pieno è €74,90",
    "offer.sub": "Forge3DLab — pacchetto completo · pagamento unico",
    "offer.incl1": "10.000+ modelli STL",
    "offer.incl2": "4 guide masterclass",
    "offer.incl3": "Sistema di gestionale completo",
    "offer.incl4": "Licenza commerciale inclusa",
    "offer.incl5": "Download digitale immediato",
    "offer.ctaMain": "Aggiungi al carrello",
    "offer.guarantee": "Checkout sicuro · €0 di spedizione · consegna immediata · garanzia 14 giorni",
    "offer.addonBadge": "Extra",
    "offer.addonSub": "Accesso agli aggiornamenti a vita",
    "offer.addon1": "Ogni futuro modello STL aggiunto — gratis",
    "offer.addon2": "Aggiornamenti delle guide e nuovi bonus",
    "offer.addon3": "La tua libreria non diventa mai obsoleta",
    "offer.ctaAddon": "Aggiungi accesso a vita",
    "guar.1": "Garanzia soddisfatti o rimborsati 14 giorni",
    "guar.2": "Download immediato",
    "guar.3": "Checkout sicuro Shopify",
    "guar.4": "Nessun abbonamento",
    "guar.5": "€0 di spedizione — 100% digitale",
    "idx.faq": "FAQ",
    "faq.title": "Domande, con risposta.",
    "faq.q1": "Cosa ottengo esattamente?",
    "faq.a1": "Il pacchetto Forge3DLab completo: 10.000+ modelli STL catalogati, 4 guide di esperti e il gestionale completo — un download digitale immediato subito dopo il checkout.",
    "faq.q2": "Posso vendere ciò che stampo?",
    "faq.a2": "Sì — è inclusa una licenza per uso commerciale completa. Stampa e vendi ciò che crei, tieni il 100% del profitto senza royalty e costruisci un vero guadagno extra.",
    "faq.q3": "Servono competenze di design o software speciali?",
    "faq.a3": "No. I file sono STL standard — funzionano con qualsiasi slicer comune (Cura, Bambu Studio, PrusaSlicer) e con qualsiasi stampante FDM o a resina. Al resto pensano le guide.",
    "faq.q4": "È un abbonamento?",
    "faq.a4": "No. Il pacchetto è un pagamento unico con accesso immediato. Gli Aggiornamenti a vita sono un extra opzionale a pagamento unico, non un addebito ricorrente.",
    "faq.q5": "E se non fa per me?",
    "faq.a5": "Sei coperto da una garanzia soddisfatti o rimborsati di 14 giorni. Se non fa per te, scrivici entro 14 giorni per un rimborso completo.",
    "final.title": "La tua stampante è pronta. Dalle qualcosa che valga la pena stampare.",
    "final.lead": "10.000+ modelli STL, guide di esperti e un gestionale completo — un solo download,",
    "final.guarantee": "€0 di spedizione · download immediato · garanzia soddisfatti o rimborsati 14 giorni",
    "footer.categories": "Categorie",
    "footer.inside": "Cosa contiene",
    "footer.reviews": "Recensioni",
    "footer.pricing": "Prezzi",
    "footer.faq": "FAQ",
    "footer.contact": "Contatti",
    "footer.privacy": "Informativa sulla privacy",
    "footer.terms": "Termini e condizioni",
    "footer.refunds": "Politica di rimborso",
    "footer.withdrawal": "Recedi dal contratto qui",
    "footer.legalContact": "Note legali",
    "footer.privacyChoices": "Le tue scelte sulla privacy",
    "footer.bot": "© 2026 Forge3DLab · Trasforma la tua stampante 3D in un guadagno · Download digitale immediato · Garanzia soddisfatti o rimborsati 14 giorni",
    "cat.c.miniatures": "Pack D&D · Lord of the Rings · Anime · Supereroi · Misti · Film & TV · Chibi · Cartoni · Giochi da tavolo",
    "cat.c.home": "Decor moderno · Funzionali · Cucina · Lampade · Formine per biscotti · Supporti per cuffie",
    "cat.c.jewelry": "3 pack completi · Anelli · Orecchini · Bracciali · Ciondoli per collane · Pendenti",
    "cat.c.keychain": "5 pack · Portachiavi personalizzati · Targhette col nome · Ciondoli personaggi",
    "cat.c.heroes": "Marvel · DC · Stile Chibi · Pose d'azione · Numerati da 1 a 645+",
    "cat.c.funko": "Serie CHIBI · PlaKit/Patreon · Roster pop-culture completo",
    "cat.c.cosplay": "Collezione ELMET-MASK · Elmi · Maschere · Props indossabili · Numerati da 1 a 300+",
    "cat.c.office": "Organizer · Accessori da scrivania · Gestione cavi · Portautensili · Upgrade postazione · Stampe per ufficio",
    "cat.hint": "Tocca una categoria per vedere cosa contiene — passa il mouse su desktop.",
    "cat.c.tools": "Chiavi · Pinze · Ganci · Morsetti · Imbuti · Strumenti di misura · Aiutanti da officina",
    "cat.c.toys": "Personaggi articolati · Antistress · Rompicapo · Automobili · Dinosauri · Stampe per bambini",
    "cat.c.vehicles": "Auto · Aerei · Carri armati · Navi · Moto · Modellini in scala"
  },
  "es": {
    "nav.home": "Inicio",
    "nav.assistance": "Ayuda",
    "announce.1": "🔥 Oferta de lanzamiento — 56% de descuento",
    "announce.2": "⚡ Descarga digital instantánea",
    "announce.3": "📦 10.000+ modelos STL",
    "announce.4": "🛡️ Garantía de devolución de 14 días",
    "announce.5": "🌍 5 idiomas incluidos",
    "hero.badge": "10.000+ modelos STL elegidos a mano, por categorías",
    "hero.title": "¿Tu impresora 3D está criando polvo?",
    "hero.lead": "10.000+ modelos STL listos para imprimir que la gente compra <b>de verdad</b> — más guías de expertos para venderlos y un gestor para llevar las cuentas. Descárgalo una vez y es tuyo para siempre: deja de pagar por cada archivo.",
    "hero.ctaGet": "Compra ahora",
    "hero.title.dusty": "Resucita esa impresora 3D que cría polvo",
    "hero.lead.dusty": "¿Esa impresora que llevas meses sin tocar? 10.000+ modelos STL listos para imprimir con los que <b>volver a encenderla</b> — más guías de expertos y un gestor para sacarle además algún dinero. Descárgalo una vez y es tuyo para siempre.",
    "hero.ctaGet.dusty": "Ponla a trabajar",
    "hero.title.search": "Deja de buscar en 20 webs el modelo perfecto",
    "hero.lead.search": "Todo lo que merece la pena imprimir, en un solo pack: 10.000+ modelos STL listos, organizados por categorías — más guías de expertos y un gestor. Descárgalo una vez, es tuyo para siempre: <b>se acabó ir a la caza de archivos</b>.",
    "hero.ctaGet.search": "Llévate toda la biblioteca",
    "hero.title.earn": "De hobby a ingresos extra",
    "hero.lead.earn": "10.000+ modelos STL listos para imprimir que la gente compra <b>de verdad</b> — más guías de expertos para venderlos y un gestor para llevar las cuentas. Descárgalo una vez, es tuyo para siempre: convierte tu impresora en una auténtica fuente de ingresos extra.",
    "hero.ctaGet.earn": "Empieza a ganar",
    "hero.ctaInside": "Ver qué incluye",
    "zoom.tipHold": "Mantén pulsado aquí",
    "zoom.tipClick": "Haz clic para ampliar",
    "hero.b1": "<b>10.000+ modelos:</b> pagas una vez, imprimes para siempre",
    "hero.b2": "<b>4 guías masterclass:</b> imprimir bien, cobrar bien, primeros clientes",
    "hero.b3": "<b>Gestor completo:</b> sabes la ganancia antes de darle a Imprimir",
    "hero.b4": "<b>Licencia comercial incluida</b> — vende lo que imprimes y quédate el 100%.",
    "hero.trust1": "💳 Pago <b>único</b> — sin suscripción",
    "hero.trust2": "⚡ Descarga digital <b>instantánea</b>",
    "hero.trust3": "🛡️ Garantía de devolución de <b>14 días</b>",
    "hero.trust4": "📦 <b>€0 de envío</b> — 100% digital",
    "hero.trust5": "📜 <b>Licencia comercial incluida</b> — vende lo que imprimes",
    "idx.categories": "Qué puedes imprimir",
    "cat.title": "¿Por qué elegir Forge3DLab?",
    "cat.lead": "No solo archivos: la biblioteca, el método para venderlos y el gestor.",
    "cat.more": "…y miles más en todas las categorías: <b>10.000+ archivos</b> en una sola descarga.",
    "idx.inside": "No solo archivos: un sistema",
    "inside.title": "Tres cosas en un solo pack. Sin adivinar.",
    "inside.lead": "Los archivos para imprimir, el conocimiento para vender lo que imprimes y el gestor que calcula costes, precios y beneficio real.",
    "inside.tag1": "01 · Biblioteca",
    "inside.h1": "10.000+ modelos STL",
    "inside.p1": "Selección categorizada y ordenada: lista para laminar en cualquier impresora.",
    "inside.tag2": "02 · Guías",
    "inside.h2": "4 guías de expertos",
    "inside.p2": "Imprime sin errores, descubre qué vende, ponle el precio justo y escala — de la primera capa a la primera venta.",
    "inside.tag3": "03 · Gestor",
    "inside.h3": "Gestor completo",
    "inside.p3": "Un sistema creado para acompañarte paso a paso.",
    "inside.cta3": "Descúbrelo ahora",
    "pain.title": "Tener una impresora no es lo difícil. Saber qué imprimir — y vender — sí lo es.",
    "pain.lead": "Buscar archivos sin fin. Pagar 8–12 $ por un solo STL. Modelos que nunca se venden. Ni idea de cuánto cobrar. Forge3DLab te da el atajo: sin necesidad de saber diseñar.",
    "idx.features": "Por qué Forge3DLab",
    "feat.title": "Todo lo que necesitas para ganar: en una sola descarga.",
    "feat.h1": "10.000+ modelos STL",
    "feat.p1": "Una biblioteca seleccionada y categorizada: decoración, funcionales, gadgets, coleccionables y superventas, lista para laminar.",
    "feat.h2": "4 guías de expertos",
    "feat.p2": "De impresiones perfectas (sin warping ni filamento desperdiciado) a qué vende, precios y escalado — todo el camino.",
    "feat.h3": "Gestor completo",
    "feat.p3": "Ve tu beneficio real tras filamento, tiempo y comisiones: gestiónalo como un negocio, no como un hobby.",
    "feat.h4": "Licencia comercial incluida",
    "feat.p4": "Incluye una licencia comercial completa — vende lo que imprimes y quédate el 100% del beneficio, sin royalties.",
    "feat.h5": "Acceso instantáneo",
    "feat.p5": "Paga una vez, descarga al instante. Sin suscripción para empezar.",
    "feat.h6": "Actualizaciones de por vida",
    "feat.p6": "Añade el acceso de por vida y cada nuevo modelo, mejora de guía y bonus aterriza en tu biblioteca: para siempre.",
    "panel1.title": "Archivos que de verdad vale la pena imprimir.",
    "panel1.lead": "Elegidos a mano y organizados — no un montón aleatorio de archivos. Ve directo a los modelos que la gente compra de verdad.",
    "idx.how": "Cómo funciona",
    "how.title": "De impresora parada a primera venta en tres pasos.",
    "how.s1h": "Descarga",
    "how.s1p": "Consigue la biblioteca completa, las guías y el gestor al instante tras la compra.",
    "how.s2h": "Imprime",
    "how.s2p": "Elige un modelo probado, lamínalo, imprímelo: las guías te dicen qué vende.",
    "how.s3h": "Vende",
    "how.s3p": "Ponle el precio justo con el gestor y convierte tu impresora en ingresos.",
    "idx.reviews": "Makers que usan Forge3DLab",
    "rev.title": "Impresoras que dejaron de acumular polvo.",
    "rev2.title": "Más impresoras que dejaron de criar polvo.",
    "idx.reviews2": "Más makers",
    "rev.avg": "4,7/5 de media · compradores verificados",
    "rev.q1": "Tuve la impresora 8 meses sin hacer nada. El primer finde con las guías vendí 3 impresiones.",
    "rev.q2": "Solo el gestor ya merece la pena. Por fin sé lo que gano de verdad por impresión.",
    "rev.q3": "Dejé de comprar archivos uno a uno. 10k modelos en un pack se amortizaron al instante.",
    "rev.q4": "Aquí nadie sabe diseñar. Las guías me dijeron exactamente qué imprimir y dónde venderlo.",
    "rev.q5": "Imprimí el set entero de magos de fantasía en un fin de semana. El detalle es increíble para FDM — mi grupo de D&D se quedó sin palabras. 🧙",
    "rev.q6": "Mi hijo quería cada personaje de su serie favorita. Imprimí 6 en dos días — uno necesitó retocar los soportes, el resto salió perfecto.",
    "rev.q7": "Las lámparas de la categoría Hogar son de otro nivel. Una está en mi salón y todos preguntan dónde la compré.",
    "rev.q8": "No creía que pudiera venderlas de verdad. Primera semana en Etsy: 4 pedidos. La guía de negocio lo cambió todo. 🔥",
    "rev.q9": "Hice tres para mi oficina en casa. Limpios, funcionales — la gente pregunta si son comprados. Vale la pena.",
    "rev.q10": "Fan de la ciencia ficción aquí. La sección de coleccionables tiene cientos de personajes. Ya imprimí 12, sin intención de parar. 😂",
    "rev.q11": "Diseños de macetas espectaculares. Imprimí cuatro, pinté dos y las vendí en un mercado local la misma semana.",
    "rev.q12": "Así se ven 3 meses de impresión. La biblioteca STL es enorme — no me he quedado sin ideas ni una vez.",
    "rev.q13": "El soporte para monitor es genial. Lo imprimí en PETG y aguanta perfectamente. Solo echo en falta alguna variante más de tamaño.",
    "rev.q14": "Mi hijo eligió la excavadora de la lista de archivos un martes. El jueves ya jugaba con ella. Magia. ✨",
    "rev.q15": "Este cajón tardó dos días en imprimirse. Sólido, encaja perfecto bajo mi escritorio. Ya he vendido tres más a compañeros.",
    "rev.q16": "La sección de oficina tiene más de 60 organizadores. He impreso cinco configuraciones — mi escritorio nunca lució mejor. 🖊️",
    "rev.verified": "Verificado",
    "panel2.title": "Todo el sistema, un solo precio.",
    "stat.models": "modelos STL",
    "stat.guides": "guías de expertos",
    "stat.categories": "Categorías",
    "stat.updates": "Actualizaciones de por vida",
    "idx.offer": "Consigue el pack",
    "offer.title": "10.000+ modelos, 4 guías y el gestor en un único paquete",
    "offer.lead": "Pago único. Acceso instantáneo. Garantía de devolución de 14 días.",
    "offer.badge": "Oferta de lanzamiento · 56% de descuento",
    "offer.launch": "Precio de lanzamiento — el precio normal es €74,90",
    "offer.sub": "Forge3DLab — pack completo · pago único",
    "offer.incl1": "10.000+ modelos STL",
    "offer.incl2": "4 guías masterclass",
    "offer.incl3": "Sistema de gestión completo",
    "offer.incl4": "Licencia comercial incluida",
    "offer.incl5": "Descarga digital instantánea",
    "offer.ctaMain": "Añadir al carrito",
    "offer.guarantee": "Pago seguro · €0 de envío · entrega instantánea · garantía de 14 días",
    "offer.addonBadge": "Complemento",
    "offer.addonSub": "Acceso a Actualizaciones de por vida",
    "offer.addon1": "Cada futuro modelo STL añadido — gratis",
    "offer.addon2": "Mejoras de guías y nuevos bonus",
    "offer.addon3": "Tu biblioteca nunca se queda obsoleta",
    "offer.ctaAddon": "Añadir de por vida",
    "guar.1": "Garantía de devolución de 14 días",
    "guar.2": "Descarga instantánea",
    "guar.3": "Pago seguro con Shopify",
    "guar.4": "Sin suscripción",
    "guar.5": "€0 de envío — 100% digital",
    "idx.faq": "FAQ",
    "faq.title": "Preguntas, respondidas.",
    "faq.q1": "¿Qué recibo exactamente?",
    "faq.a1": "El pack completo de Forge3DLab: 10.000+ modelos STL categorizados, 4 guías de expertos y el gestor completo, en una descarga digital instantánea justo tras la compra.",
    "faq.q2": "¿Puedo vender lo que imprimo?",
    "faq.a2": "Sí — se incluye una licencia de uso comercial completa. Imprime y vende lo que haces, quédate el 100% del beneficio sin royalties y crea unos ingresos extra reales.",
    "faq.q3": "¿Necesito saber diseñar o un software especial?",
    "faq.a3": "No. Los archivos son STL estándar: funcionan con cualquier laminador habitual (Cura, Bambu Studio, PrusaSlicer) y cualquier impresora FDM o de resina. Las guías se encargan del resto.",
    "faq.q4": "¿Es una suscripción?",
    "faq.a4": "No. El pack es un pago único con acceso instantáneo. Las Actualizaciones de por vida son un complemento opcional de pago único, no un cargo recurrente.",
    "faq.q5": "¿Y si no es para mí?",
    "faq.a5": "Estás cubierto por una garantía de devolución de 14 días. Si no encaja, escríbenos dentro de 14 días y te devolvemos todo el dinero.",
    "final.title": "Tu impresora está lista. Dale algo que valga la pena imprimir.",
    "final.lead": "10.000+ modelos STL, guías de expertos y un gestor completo: una descarga,",
    "final.guarantee": "€0 de envío · descarga instantánea · garantía de devolución de 14 días",
    "footer.categories": "Categorías",
    "footer.inside": "Qué incluye",
    "footer.reviews": "Reseñas",
    "footer.pricing": "Precio",
    "footer.faq": "FAQ",
    "footer.contact": "Contacto",
    "footer.privacy": "Política de privacidad",
    "footer.terms": "Términos del servicio",
    "footer.refunds": "Política de reembolso",
    "footer.withdrawal": "Desistir del contrato aquí",
    "footer.legalContact": "Aviso legal",
    "footer.privacyChoices": "Tus opciones de privacidad",
    "footer.bot": "© 2026 Forge3DLab · Convierte tu impresora 3D en ingresos · Descarga digital instantánea · Garantía de devolución de 14 días",
    "cat.c.miniatures": "Packs de D&D · Lord of the Rings · Anime · Superhéroes · Variados · Cine y TV · Chibi · Dibujos animados · Juegos de mesa",
    "cat.c.home": "Decoración moderna · Funcional · Cocina · Lámparas · Cortadores de galletas · Soportes para auriculares",
    "cat.c.jewelry": "3 packs completos · Anillos · Pendientes · Pulseras · Colgantes para collar · Colgantes",
    "cat.c.keychain": "5 packs · Llaveros personalizados · Placas con nombre · Colgantes de personajes",
    "cat.c.heroes": "Marvel · DC · Estilo Chibi · Poses de acción · Numerados del 1 al 645+",
    "cat.c.funko": "Serie CHIBI · PlaKit/Patreon · Elenco completo de cultura pop",
    "cat.c.cosplay": "Colección ELMET-MASK · Cascos · Máscaras · Props para llevar · Numerados del 1 al 300+",
    "cat.c.office": "Organizadores · Accesorios de escritorio · Gestión de cables · Soportes para herramientas · Mejoras del espacio de trabajo · Impresiones de oficina",
    "cat.hint": "Toca una categoría para ver qué incluye — pasa el cursor en escritorio.",
    "cat.c.tools": "Llaves · Alicates · Ganchos · Abrazaderas · Embudos · Herramientas de medición · Ayudantes de taller",
    "cat.c.toys": "Figuras articuladas · Juguetes antiestrés · Puzzles · Coches · Dinosaurios · Impresiones para niños",
    "cat.c.vehicles": "Coches · Aviones · Tanques · Barcos · Motocicletas · Maquetas a escala"
  },
  "de": {
    "nav.home": "Start",
    "nav.assistance": "Support",
    "announce.1": "🔥 Launch-Angebot — 56% Rabatt",
    "announce.2": "⚡ Sofortiger Download",
    "announce.3": "📦 10.000+ STL-Modelle",
    "announce.4": "🛡️ 14 Tage Geld-zurück-Garantie",
    "announce.5": "🌍 5 Sprachen inklusive",
    "hero.badge": "10.000+ handverlesene STL-Modelle, nach Kategorien sortiert",
    "hero.title": "Verstaubt dein 3D-Drucker?",
    "hero.lead": "10.000+ druckfertige STL-Modelle, die Leute <b>wirklich kaufen</b> — plus Experten-Guides zum Verkaufen und ein kompletter Business-Manager für die Zahlen. Einmal herunterladen, für immer behalten und Schluss mit dem Zahlen für jede einzelne Datei.",
    "hero.ctaGet": "Jetzt kaufen",
    "hero.title.dusty": "Erweck deinen verstaubten 3D-Drucker zum Leben",
    "hero.lead.dusty": "Der Drucker, der nur rumsteht? 10.000+ druckfertige STL-Modelle, um ihn <b>wieder anzuwerfen</b> — plus Experten-Guides und ein kompletter Business-Manager, um damit auch noch Geld zu verdienen. Einmal herunterladen, für immer behalten.",
    "hero.ctaGet.dusty": "Lass ihn wieder arbeiten",
    "hero.title.search": "Schluss mit der Suche auf 20 Seiten nach dem perfekten Modell",
    "hero.lead.search": "Alles, was sich zu drucken lohnt, in einem Paket: 10.000+ druckfertige STL-Modelle, nach Kategorien sortiert — plus Experten-Guides und ein kompletter Business-Manager. Einmal herunterladen, für immer behalten — <b>nie wieder auf Dateijagd</b>.",
    "hero.ctaGet.search": "Ganze Bibliothek sichern",
    "hero.title.earn": "Vom Hobby zum Nebeneinkommen",
    "hero.lead.earn": "10.000+ druckfertige STL-Modelle, die Leute <b>wirklich kaufen</b> — plus Experten-Guides zum Verkaufen und ein kompletter Business-Manager für die Zahlen. Einmal herunterladen, für immer behalten — und mach aus deinem Drucker ein echtes Nebeneinkommen.",
    "hero.ctaGet.earn": "Jetzt verdienen",
    "hero.ctaInside": "Blick ins Paket",
    "zoom.tipHold": "Hier gedrückt halten",
    "zoom.tipClick": "Zum Vergrößern klicken",
    "hero.b1": "<b>10.000+ Modelle:</b> einmal zahlen, für immer drucken",
    "hero.b2": "<b>4 Masterclass-Guides:</b> perfekte Drucke, faire Preise, erste Kunden",
    "hero.b3": "<b>Kompletter Business-Manager:</b> den Gewinn kennst du vor dem Start",
    "hero.b4": "<b>Kommerzielle Lizenz inklusive</b> — verkaufe, was du druckst, und behalte 100%.",
    "hero.trust1": "💳 <b>Einmalige</b> Zahlung — kein Abo",
    "hero.trust2": "⚡ <b>Sofortiger</b> Download",
    "hero.trust3": "🛡️ <b>14 Tage</b> Geld-zurück-Garantie",
    "hero.trust4": "📦 <b>0 € Versand</b> — 100% digital",
    "hero.trust5": "📜 <b>Kommerzielle Lizenz inklusive</b> — verkaufe, was du druckst",
    "idx.categories": "Was du drucken kannst",
    "cat.title": "Warum Forge3DLab wählen?",
    "cat.lead": "Nicht nur Dateien: die Bibliothek, die Verkaufsmethode und das Werkzeug.",
    "cat.more": "…und tausende mehr in jeder Kategorie — <b>10.000+ Dateien</b> in einem Download.",
    "idx.inside": "Nicht nur Dateien — ein System",
    "inside.title": "Drei Dinge in einem Paket. Kein Rätselraten.",
    "inside.lead": "Die Dateien zum Drucken, das Know-how, um deine Drucke zu verkaufen, und der Manager für Kosten, Preise und echten Gewinn.",
    "inside.tag1": "01 · Bibliothek",
    "inside.h1": "10.000+ STL-Modelle",
    "inside.p1": "Kategorisiert und sortiert — bereit zum Slicen auf jedem Drucker.",
    "inside.tag2": "02 · Guides",
    "inside.h2": "4 Experten-Guides",
    "inside.p2": "Fehlerfrei drucken, herausfinden, was sich verkauft, richtig kalkulieren und skalieren — vom ersten Layer bis zum ersten Verkauf.",
    "inside.tag3": "03 · Manager",
    "inside.h3": "Kompletter Business-Manager",
    "inside.p3": "Ein System, das dich Schritt für Schritt begleitet.",
    "inside.cta3": "Jetzt entdecken",
    "pain.title": "Einen Drucker zu besitzen ist nicht das Schwere. Zu wissen, was du drucken — und verkaufen — sollst, schon.",
    "pain.lead": "Endlose Dateisuche. $8–12 pro einzelner STL. Modelle, die sich nie verkaufen. Keine Ahnung, was du verlangen sollst. Forge3DLab liefert dir die Abkürzung — ganz ohne Design-Kenntnisse.",
    "idx.features": "Warum Forge3DLab",
    "feat.title": "Alles, was du zum Verdienen brauchst — in einem Download.",
    "feat.h1": "10.000+ STL-Modelle",
    "feat.p1": "Eine kuratierte, kategorisierte Bibliothek — Deko, Funktionsteile, Gadgets, Sammlerstücke und Bestseller, bereit zum Slicen.",
    "feat.h2": "4 Experten-Guides",
    "feat.p2": "Von perfekten Drucken (kein Warping, kein verschwendetes Filament) bis zu dem, was sich verkauft, Preisen und Skalierung — der ganze Weg.",
    "feat.h3": "Kompletter Business-Manager",
    "feat.p3": "Sieh deinen echten Gewinn nach Filament, Zeit und Gebühren — führ es wie ein Business, nicht wie ein Hobby.",
    "feat.h4": "Kommerzielle Lizenz inklusive",
    "feat.p4": "Eine vollständige kommerzielle Lizenz ist enthalten — verkaufe, was du druckst, und behalte 100% deines Gewinns, ohne Lizenzgebühren.",
    "feat.h5": "Sofortiger Zugang",
    "feat.p5": "Einmal zahlen, sofort herunterladen. Kein Abo nötig, um loszulegen.",
    "feat.h6": "Lebenslange Updates",
    "feat.p6": "Füge lebenslangen Zugang hinzu und jedes neue Modell, Guide-Upgrade und jeder Bonus landet in deiner Bibliothek — für immer.",
    "panel1.title": "Dateien, die sich wirklich zu drucken lohnen.",
    "panel1.lead": "Handverlesen und sortiert — kein wahlloser Haufen von Dateien. Direkt zu Modellen, die Leute wirklich kaufen.",
    "idx.how": "So funktioniert's",
    "how.title": "Vom untätigen Drucker zum ersten Verkauf in drei Schritten.",
    "how.s1h": "Download",
    "how.s1p": "Erhalte die komplette Bibliothek, Guides und Manager sofort nach dem Kauf.",
    "how.s2h": "Drucken",
    "how.s2p": "Wähl ein bewährtes Modell, slice es, druck — die Guides sagen dir, was sich verkauft.",
    "how.s3h": "Verkaufen",
    "how.s3p": "Kalkuliere den Preis richtig mit dem Manager und mach deinen Drucker zur Einnahmequelle.",
    "idx.reviews": "Maker, die Forge3DLab nutzen",
    "rev.title": "Drucker, die keinen Staub mehr ansetzen.",
    "rev2.title": "Weitere Drucker, die keinen Staub mehr ansetzen.",
    "idx.reviews2": "Weitere Maker",
    "rev.avg": "4,7/5 im Schnitt · verifizierte Käufer",
    "rev.q1": "Mein Drucker stand 8 Monate ungenutzt herum. Am ersten Wochenende mit den Guides habe ich 3 Drucke verkauft.",
    "rev.q2": "Allein der Manager lohnt sich. Endlich weiß ich, was ich pro Druck wirklich verdiene.",
    "rev.q3": "Schluss mit dem Kauf einzelner Dateien. 10k Modelle in einem Paket haben sich sofort bezahlt gemacht.",
    "rev.q4": "Keine Design-Kenntnisse hier. Die Guides sagten mir genau, was ich drucken und wo ich es verkaufen soll.",
    "rev.q5": "Das komplette Fantasy-Magier-Set an einem Wochenende gedruckt. Die Details sind der Wahnsinn für FDM — meine D&D-Gruppe war sprachlos. 🧙",
    "rev.q6": "Mein Sohn wollte jede Figur aus seiner Lieblingsserie. 6 in zwei Tagen gedruckt — bei einer musste ich die Supports nachjustieren, der Rest kam perfekt raus.",
    "rev.q7": "Die Lampen-Designs in der Kategorie Home sind eine andere Liga. Eine steht jetzt in meinem Wohnzimmer und alle fragen, wo ich sie gekauft habe.",
    "rev.q8": "Ich hätte nicht geglaubt, dass ich die wirklich verkaufen kann. Erste Woche auf Etsy: 4 Bestellungen. Der Business-Guide hat alles verändert. 🔥",
    "rev.q9": "Drei davon für mein Homeoffice gemacht. Sauber, funktional — Leute fragen ständig, ob sie gekauft sind. Lohnt sich.",
    "rev.q10": "Sci-Fi-Fan hier. Die Sammlerstücke-Sektion hat Hunderte Figuren. Schon 12 gedruckt, kein Ende in Sicht. 😂",
    "rev.q11": "Wunderschöne Pflanzentopf-Designs. Vier gedruckt, zwei bemalt und in derselben Woche auf einem lokalen Markt verkauft.",
    "rev.q12": "So sehen 3 Monate Drucken aus. Die STL-Bibliothek ist riesig — mir sind kein einziges Mal die Ideen ausgegangen.",
    "rev.q13": "Der Monitorständer-STL ist genial. In PETG gedruckt, hält perfekt. Ein paar Größenvarianten mehr wären noch schön.",
    "rev.q14": "Mein Kind hat an einem Dienstag den Bagger aus der Dateiliste ausgesucht. Am Donnerstag hat es damit gespielt. Magie. ✨",
    "rev.q15": "Dieser Schubladenschrank brauchte zwei Tage Druck. Stabil, passt perfekt unter meinen Schreibtisch. Habe seitdem drei weitere an Kollegen verkauft.",
    "rev.q16": "Die Büro-Sektion hat über 60 Organizer-Designs. Fünf Konfigurationen gedruckt — mein Schreibtisch war nie aufgeräumter. 🖊️",
    "rev.verified": "Verifiziert",
    "panel2.title": "Das komplette System, ein Preis.",
    "stat.models": "STL-Modelle",
    "stat.guides": "Experten-Guides",
    "stat.categories": "Kategorien",
    "stat.updates": "Lebenslange Updates",
    "idx.offer": "Bundle sichern",
    "offer.title": "10.000+ Modelle, 4 Guides, ein Manager. Ein Paket.",
    "offer.lead": "Einmalige Zahlung. Sofortiger Zugang. 14 Tage Geld-zurück-Garantie.",
    "offer.badge": "Einführungsangebot · 56% Rabatt",
    "offer.launch": "Einführungspreis — regulär €74,90",
    "offer.sub": "Forge3DLab — komplettes Bundle · einmalig",
    "offer.incl1": "10.000+ STL-Modelle",
    "offer.incl2": "4 Masterclass-Guides",
    "offer.incl3": "Komplettes Business-Manager-System",
    "offer.incl4": "Kommerzielle Lizenz inklusive",
    "offer.incl5": "Sofortiger Download",
    "offer.ctaMain": "In den Warenkorb",
    "offer.guarantee": "Sicherer Checkout · 0 € Versand · sofortige Lieferung · 14 Tage Garantie",
    "offer.addonBadge": "Add-on",
    "offer.addonSub": "Lebenslanger Update-Zugang",
    "offer.addon1": "Jedes künftige STL-Modell — kostenlos",
    "offer.addon2": "Guide-Upgrades & neue Boni",
    "offer.addon3": "Deine Bibliothek veraltet nie",
    "offer.ctaAddon": "Lebenslang hinzufügen",
    "guar.1": "14 Tage Geld-zurück-Garantie",
    "guar.2": "Sofortiger Download",
    "guar.3": "Sicherer Shopify-Checkout",
    "guar.4": "Kein Abo",
    "guar.5": "0 € Versand — 100% digital",
    "idx.faq": "FAQ",
    "faq.title": "Fragen, beantwortet.",
    "faq.q1": "Was genau bekomme ich?",
    "faq.a1": "Das komplette Forge3DLab-Bundle: 10.000+ kategorisierte STL-Modelle, 4 Experten-Guides und der komplette Business-Manager — als sofortiger Download direkt nach dem Kauf.",
    "faq.q2": "Darf ich verkaufen, was ich drucke?",
    "faq.a2": "Ja — eine vollständige Lizenz zur kommerziellen Nutzung ist enthalten. Drucke und verkaufe, was du herstellst, behalte 100% deines Gewinns ohne Lizenzgebühren und bau ein echtes Nebeneinkommen auf.",
    "faq.q3": "Brauche ich Design-Kenntnisse oder spezielle Software?",
    "faq.a3": "Nein. Die Dateien sind Standard-STL — sie funktionieren mit jedem gängigen Slicer (Cura, Bambu Studio, PrusaSlicer) und jedem FDM- oder Resin-Drucker. Den Rest übernehmen die Guides.",
    "faq.q4": "Ist es ein Abo?",
    "faq.a4": "Nein. Das Bundle ist eine einmalige Zahlung mit sofortigem Zugang. Lebenslange Updates sind ein optionales, einmaliges Add-on — keine wiederkehrende Gebühr.",
    "faq.q5": "Was, wenn es nichts für mich ist?",
    "faq.a5": "Du bist durch eine 14-tägige Geld-zurück-Garantie abgesichert. Passt es nicht, schreib uns innerhalb von 14 Tagen für eine volle Rückerstattung.",
    "final.title": "Dein Drucker ist bereit. Gib ihm etwas, das sich zu drucken lohnt.",
    "final.lead": "10.000+ STL-Modelle, Experten-Guides und ein Kompletter Business-Manager — ein Download,",
    "final.guarantee": "0 € Versand · Sofort-Download · 14 Tage Geld-zurück-Garantie",
    "footer.categories": "Kategorien",
    "footer.inside": "Was drin ist",
    "footer.reviews": "Bewertungen",
    "footer.pricing": "Preise",
    "footer.faq": "FAQ",
    "footer.contact": "Kontakt",
    "footer.privacy": "Datenschutzerklärung",
    "footer.terms": "AGB",
    "footer.refunds": "Rückerstattungsrichtlinie",
    "footer.withdrawal": "Vertrag hier widerrufen",
    "footer.legalContact": "Impressum",
    "footer.privacyChoices": "Deine Datenschutzoptionen",
    "footer.bot": "© 2026 Forge3DLab · Mach deinen 3D-Drucker zur Einnahmequelle · Sofortiger Download · 14 Tage Geld-zurück-Garantie",
    "cat.c.miniatures": "D&D-Packs · Lord of the Rings · Anime · Superhelden · Gemischt · Film & TV · Chibi · Cartoons · Brettspiele",
    "cat.c.home": "Modernes Deko · Funktional · Küche · Lampen · Keksausstecher · Kopfhörerständer",
    "cat.c.jewelry": "3 komplette Packs · Ringe · Ohrringe · Armbänder · Halskettenanhänger · Anhänger",
    "cat.c.keychain": "5 Packs · Individuelle Schlüsselanhänger · Individuelle Namensschilder · Charakteranhänger",
    "cat.c.heroes": "Marvel · DC · Chibi-Stil · Action-Posen · Nummeriert 1 bis 645+",
    "cat.c.funko": "CHIBI-Serie · PlaKit/Patreon · Komplettes Popkultur-Aufgebot",
    "cat.c.cosplay": "ELMET-MASK Kollektion · Helme · Masken · Tragbare Props · Nummeriert 1 bis 300+",
    "cat.c.office": "Organizer · Schreibtisch-Zubehör · Kabelmanagement · Werkzeughalter · Workspace-Upgrades · Büro-Prints",
    "cat.hint": "Tippe auf eine Kategorie, um den Inhalt zu sehen — am Desktop mit der Maus.",
    "cat.c.tools": "Schraubenschlüssel · Zangen · Haken · Klemmen · Trichter · Messwerkzeuge · Werkstatthelfer",
    "cat.c.toys": "Bewegliche Figuren · Fidget-Spielzeug · Puzzles · Autos · Dinosaurier · Kinderdrucke",
    "cat.c.vehicles": "Autos · Flugzeuge · Panzer · Schiffe · Motorräder · Maßstabsmodelle"
  },
  "fr": {
    "nav.home": "Accueil",
    "nav.assistance": "Assistance",
    "announce.1": "🔥 Offre de lancement — 56% de réduction",
    "announce.2": "⚡ Téléchargement numérique instantané",
    "announce.3": "📦 10 000+ modèles STL",
    "announce.4": "🛡️ Garantie satisfait ou remboursé sous 14 jours",
    "announce.5": "🌍 5 langues incluses",
    "hero.badge": "10 000+ modèles STL choisis à la main, classés par catégorie",
    "hero.title": "Votre imprimante 3D prend la poussière ?",
    "hero.lead": "10 000+ modèles STL prêts à imprimer que les gens achètent <b>vraiment</b> — plus des guides d'experts pour les vendre et un gestionnaire complet pour gérer les chiffres. Téléchargez une fois, gardez à vie : fini de payer chaque fichier.",
    "hero.ctaGet": "Acheter maintenant",
    "hero.title.dusty": "Dépoussiérez votre imprimante 3D",
    "hero.lead.dusty": "Cette imprimante qui dort dans un coin ? 10 000+ modèles STL prêts à imprimer pour <b>la remettre en route</b> — plus des guides d'experts et un gestionnaire complet pour en tirer un peu d'argent. Téléchargez une fois, gardez à vie.",
    "hero.ctaGet.dusty": "Remettez-la au travail",
    "hero.title.search": "Fini de chercher le modèle parfait sur 20 sites",
    "hero.lead.search": "Tout ce qui vaut la peine d'être imprimé, en un seul pack : 10 000+ modèles STL prêts à imprimer, classés par catégorie — plus des guides d'experts et un gestionnaire complet. Téléchargez une fois, gardez à vie : <b>fini la chasse aux fichiers</b>.",
    "hero.ctaGet.search": "Prenez toute la bibliothèque",
    "hero.title.earn": "Du hobby au revenu d'appoint",
    "hero.lead.earn": "10 000+ modèles STL prêts à imprimer que les gens achètent <b>vraiment</b> — plus des guides d'experts pour les vendre et un gestionnaire complet pour gérer les chiffres. Téléchargez une fois, gardez à vie, et faites de votre imprimante une vraie source de revenus.",
    "hero.ctaGet.earn": "Commencez à gagner",
    "hero.ctaInside": "Voir le contenu",
    "zoom.tipHold": "Maintenez appuyé ici",
    "zoom.tipClick": "Cliquez pour agrandir",
    "hero.b1": "<b>10 000+ modèles :</b> vous payez une fois, vous imprimez pour toujours",
    "hero.b2": "<b>4 guides masterclass :</b> impressions parfaites, bons prix, premiers clients",
    "hero.b3": "<b>Gestionnaire complet :</b> vous savez le gain avant d’appuyer sur Imprimer",
    "hero.b4": "<b>Licence commerciale incluse</b> — vends ce que tu imprimes et garde 100%.",
    "hero.trust1": "💳 Paiement <b>unique</b> — sans abonnement",
    "hero.trust2": "⚡ Téléchargement numérique <b>instantané</b>",
    "hero.trust3": "🛡️ Garantie satisfait ou remboursé sous <b>14 jours</b>",
    "hero.trust4": "📦 <b>0 € de livraison</b> — 100% numérique",
    "hero.trust5": "📜 <b>Licence commerciale incluse</b> — vendez ce que vous imprimez",
    "idx.categories": "Ce que vous pouvez imprimer",
    "cat.title": "Pourquoi choisir Forge3DLab ?",
    "cat.lead": "Pas seulement des fichiers : la bibliothèque, la méthode de vente et l’outil.",
    "cat.more": "…et des milliers d'autres dans chaque catégorie — <b>10 000+ fichiers</b> en un seul téléchargement.",
    "idx.inside": "Pas juste des fichiers — un système",
    "inside.title": "Trois choses dans un seul pack. Sans deviner.",
    "inside.lead": "Les fichiers à imprimer, le savoir-faire pour vendre ce que vous imprimez et le gestionnaire qui calcule coûts, prix et profit réel.",
    "inside.tag1": "01 · Bibliothèque",
    "inside.h1": "10 000+ modèles STL",
    "inside.p1": "Sélections classées et organisées — prêtes à trancher sur n'importe quelle imprimante.",
    "inside.tag2": "02 · Guides",
    "inside.h2": "4 guides d'experts",
    "inside.p2": "Imprimez sans défaut, trouvez ce qui se vend, fixez le bon prix et développez — de la première couche à la première vente.",
    "inside.tag3": "03 · Gestion",
    "inside.h3": "Gestionnaire complet",
    "inside.p3": "Un système conçu pour vous suivre pas à pas.",
    "inside.cta3": "Découvrir maintenant",
    "pain.title": "Posséder une imprimante n'est pas le plus dur. Savoir quoi imprimer — et vendre — l'est.",
    "pain.lead": "Des heures à chercher des fichiers. Payer 8–12 $ le STL. Des modèles qui ne se vendent jamais. Aucune idée du prix à fixer. Forge3DLab vous offre le raccourci — sans aucune compétence en design.",
    "idx.features": "Pourquoi Forge3DLab",
    "feat.title": "Tout ce qu'il vous faut pour gagner — en un téléchargement.",
    "feat.h1": "10 000+ modèles STL",
    "feat.p1": "Une bibliothèque sélectionnée et classée — déco, fonctionnel, gadgets, objets de collection et best-sellers, prêts à trancher.",
    "feat.h2": "4 guides d'experts",
    "feat.p2": "Des impressions parfaites (fini le warping et le filament gaspillé) à ce qui se vend, aux prix et au développement — tout le parcours.",
    "feat.h3": "Gestionnaire complet",
    "feat.p3": "Voyez votre vrai profit après filament, temps et frais — gérez ça comme une entreprise, pas un loisir.",
    "feat.h4": "Licence commerciale incluse",
    "feat.p4": "Une licence commerciale complète est incluse — vendez ce que vous imprimez et gardez 100% de votre profit, sans redevances.",
    "feat.h5": "Accès instantané",
    "feat.p5": "Payez une fois, téléchargez immédiatement. Aucun abonnement requis pour démarrer.",
    "feat.h6": "Mises à jour à vie",
    "feat.p6": "Ajoutez l'accès à vie et chaque nouveau modèle, amélioration de guide et bonus arrive dans votre bibliothèque — pour toujours.",
    "panel1.title": "Des fichiers qui valent vraiment la peine d'être imprimés.",
    "panel1.lead": "Choisis à la main et organisés — pas un tas de fichiers au hasard. Allez droit aux modèles que les gens achètent vraiment.",
    "idx.how": "Comment ça marche",
    "how.title": "D'une imprimante inactive à votre première vente en trois étapes.",
    "how.s1h": "Télécharger",
    "how.s1p": "Obtenez la bibliothèque complète, les guides et le gestionnaire instantanément après l'achat.",
    "how.s2h": "Imprimer",
    "how.s2p": "Choisissez un modèle éprouvé, tranchez-le, imprimez — les guides vous disent ce qui se vend.",
    "how.s3h": "Vendre",
    "how.s3p": "Fixez le bon prix avec le gestionnaire et transformez votre imprimante en source de revenus.",
    "idx.reviews": "Des makers qui utilisent Forge3DLab",
    "rev.title": "Des imprimantes qui ont cessé de prendre la poussière.",
    "rev2.title": "D’autres imprimantes qui ont cessé de prendre la poussière.",
    "idx.reviews2": "D’autres makers",
    "rev.avg": "4,7/5 de moyenne · acheteurs vérifiés",
    "rev.q1": "Mon imprimante dormait depuis 8 mois. Dès le premier week-end avec les guides, j'ai vendu 3 impressions.",
    "rev.q2": "Le gestionnaire vaut à lui seul l'achat. Je sais enfin ce que je gagne réellement par impression.",
    "rev.q3": "Fini d'acheter les fichiers un par un. 10k modèles en un pack, rentabilisé immédiatement.",
    "rev.q4": "Aucune compétence en design ici. Les guides m'ont dit exactement quoi imprimer et où le vendre.",
    "rev.q5": "J'ai imprimé tout le set de mages fantasy en un week-end. Le niveau de détail est dingue pour du FDM — mon groupe de D&D était bouche bée. 🧙",
    "rev.q6": "Mon fils voulait chaque personnage de sa série préférée. 6 imprimés en deux jours — un seul a demandé un réglage des supports, les autres sont sortis nickel.",
    "rev.q7": "Les designs de lampes de la catégorie Maison sont d'un autre niveau. J'en ai une dans mon salon et tout le monde demande où je l'ai achetée.",
    "rev.q8": "Je ne croyais pas pouvoir vraiment les vendre. Première semaine sur Etsy : 4 commandes. Le guide business a tout changé. 🔥",
    "rev.q9": "J'en ai fait trois pour mon bureau à la maison. Nets, fonctionnels — les gens demandent s'ils sont achetés en magasin. Ça vaut le coup.",
    "rev.q10": "Fan de science-fiction ici. La section objets de collection compte des centaines de personnages. Déjà 12 imprimés, pas près de m'arrêter. 😂",
    "rev.q11": "Designs de jardinières superbes. Quatre imprimées, deux peintes, vendues sur un marché local la même semaine.",
    "rev.q12": "Voilà à quoi ressemblent 3 mois d'impression. La bibliothèque STL est immense — je n'ai jamais manqué d'idées.",
    "rev.q13": "Le support d'écran STL est génial. Imprimé en PETG, il tient parfaitement. J'aimerais juste quelques variantes de taille en plus.",
    "rev.q14": "Mon enfant a choisi la pelleteuse dans la liste de fichiers un mardi. Jeudi, il jouait déjà avec. Magique. ✨",
    "rev.q15": "Ce caisson à tiroirs a pris deux jours d'impression. Solide, se glisse parfaitement sous mon bureau. J'en ai vendu trois autres à des collègues depuis.",
    "rev.q16": "La section bureau compte plus de 60 organiseurs. J'ai imprimé cinq configurations — mon bureau n'a jamais été aussi bien rangé. 🖊️",
    "rev.verified": "Vérifié",
    "panel2.title": "Tout le système, un seul prix.",
    "stat.models": "Modèles STL",
    "stat.guides": "Guides d'experts",
    "stat.categories": "Catégories",
    "stat.updates": "Mises à jour à vie",
    "idx.offer": "Obtenir le pack",
    "offer.title": "10 000+ modèles, 4 guides et le gestionnaire, un pack",
    "offer.lead": "Paiement unique. Accès instantané. Garantie satisfait ou remboursé sous 14 jours.",
    "offer.badge": "Offre de lancement · 56% de réduction",
    "offer.launch": "Prix de lancement — prix normal €74,90",
    "offer.sub": "Forge3DLab — pack complet · paiement unique",
    "offer.incl1": "10 000+ modèles STL",
    "offer.incl2": "4 guides masterclass",
    "offer.incl3": "Système de gestion complet",
    "offer.incl4": "Licence commerciale incluse",
    "offer.incl5": "Téléchargement numérique instantané",
    "offer.ctaMain": "Ajouter au panier",
    "offer.guarantee": "Paiement sécurisé · 0 € de livraison · livraison instantanée · garantie 14 jours",
    "offer.addonBadge": "Option",
    "offer.addonSub": "Accès aux mises à jour à vie",
    "offer.addon1": "Chaque futur modèle STL ajouté — gratuit",
    "offer.addon2": "Améliorations de guides et nouveaux bonus",
    "offer.addon3": "Votre bibliothèque ne vieillit jamais",
    "offer.ctaAddon": "Ajouter l'accès à vie",
    "guar.1": "Garantie satisfait ou remboursé sous 14 jours",
    "guar.2": "Téléchargement instantané",
    "guar.3": "Paiement Shopify sécurisé",
    "guar.4": "Sans abonnement",
    "guar.5": "0 € de livraison — 100% numérique",
    "idx.faq": "FAQ",
    "faq.title": "Vos questions, nos réponses.",
    "faq.q1": "Qu'est-ce que je reçois exactement ?",
    "faq.a1": "Le pack Forge3DLab complet : 10 000+ modèles STL classés, 4 guides d'experts et le gestionnaire complet — un téléchargement numérique instantané juste après l'achat.",
    "faq.q2": "Puis-je vendre ce que j'imprime ?",
    "faq.a2": "Oui — une licence d'usage commercial complète est incluse. Imprimez et vendez ce que vous fabriquez, gardez 100% de votre profit sans redevances et bâtissez un vrai revenu complémentaire.",
    "faq.q3": "Ai-je besoin de compétences en design ou d'un logiciel spécial ?",
    "faq.a3": "Non. Les fichiers sont au format STL standard — ils fonctionnent avec tout slicer courant (Cura, Bambu Studio, PrusaSlicer) et toute imprimante FDM ou résine. Les guides s'occupent du reste.",
    "faq.q4": "Est-ce un abonnement ?",
    "faq.a4": "Non. Le pack est un paiement unique avec accès instantané. Les mises à jour à vie sont une option ponctuelle facultative, pas un prélèvement récurrent.",
    "faq.q5": "Et si ça ne me convient pas ?",
    "faq.a5": "Vous êtes couvert par une garantie satisfait ou remboursé sous 14 jours. Si ça ne vous convient pas, écrivez-nous sous 14 jours pour un remboursement intégral.",
    "final.title": "Votre imprimante est prête. Donnez-lui quelque chose qui vaut la peine d'être imprimé.",
    "final.lead": "10 000+ modèles STL, guides d'experts et un gestionnaire complet — un seul téléchargement,",
    "final.guarantee": "0 € de livraison · téléchargement immédiat · garantie satisfait ou remboursé sous 14 jours",
    "footer.categories": "Catégories",
    "footer.inside": "Le contenu",
    "footer.reviews": "Avis",
    "footer.pricing": "Tarifs",
    "footer.faq": "FAQ",
    "footer.contact": "Contact",
    "footer.privacy": "Politique de confidentialité",
    "footer.terms": "Conditions d'utilisation",
    "footer.refunds": "Politique de remboursement",
    "footer.withdrawal": "Se rétracter du contrat ici",
    "footer.legalContact": "Mentions légales",
    "footer.privacyChoices": "Vos choix de confidentialité",
    "footer.bot": "© 2026 Forge3DLab · Transformez votre imprimante 3D en source de revenus · Téléchargement numérique instantané · Garantie satisfait ou remboursé sous 14 jours",
    "cat.c.miniatures": "Packs D&D · Lord of the Rings · Anime · Super-héros · Mixte · Ciné & TV · Chibi · Dessins animés · Jeux de plateau",
    "cat.c.home": "Déco moderne · Fonctionnel · Cuisine · Lampes · Emporte-pièces · Supports casque",
    "cat.c.jewelry": "3 packs complets · Bagues · Boucles d'oreilles · Bracelets · Breloques de collier · Pendentifs",
    "cat.c.keychain": "5 packs · Porte-clés personnalisés · Étiquettes prénom personnalisées · Breloques personnages",
    "cat.c.heroes": "Marvel · DC · Style Chibi · Poses d'action · Numérotés 1 à 645+",
    "cat.c.funko": "Série CHIBI · PlaKit/Patreon · Panoplie pop-culture complète",
    "cat.c.cosplay": "Collection ELMET-MASK · Casques · Masques · Accessoires portables · Numérotés 1 à 300+",
    "cat.c.office": "Organiseurs · Accessoires de bureau · Gestion des câbles · Porte-outils · Optimisations d'espace · Impressions bureau",
    "cat.hint": "Touchez une catégorie pour voir le contenu — survolez sur ordinateur.",
    "cat.c.tools": "Clés · Pinces · Crochets · Serre-joints · Entonnoirs · Outils de mesure · Accessoires d'atelier",
    "cat.c.toys": "Figurines articulées · Jouets anti-stress · Casse-têtes · Voitures · Dinosaures · Impressions pour enfants",
    "cat.c.vehicles": "Voitures · Avions · Chars · Navires · Motos · Modèles réduits"
  }
};
